/** Специализированные функции, обеспечивающие формирование условий отбора для virtuoso.
 * Задание условий осуществляется массивом элементов. Каждый элемент содержит
 * {predicate: "", operator: "", value: "", alias:"", label:"", type:""}, где
 *  predicate - значение предиката, с которое содержит значение
 *  operator - оператор условия,
 *  value - значение для сравнения. Если значение задано массивом, то элементы идут как логическое ИЛИ (||)
 *  label - для UI отображения условия (например, задан IRI, а в label - наименование)
 *  type - тип условия. М.б. literal или uri
 * 
 * Например,
 * {predicate: "http://www.w3.org/2000/01/rdf-schema#label", operator: "contains", value: "ядр", alias:"dsn", label:"ядр", type:"literal"}
 */
/** Примеры запросов 
Поиск по первой букве и названию:
select ?IRI ?dsn ?dsv 
where {  <http://hbz.ru/adms/catalog> <http://www.w3.org/ns/dcat#dataset> ?IRI .
                                 ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn .
                       OPTIONAL{ ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv }
    FILTER (  strStarts(?dsn, "Д") && contains(?dsn, "убл") )} 
 *
 *
 * 
 Пример по первой букве, названию и ссылки на концепт
select ?IRI ?dsn ?dsv 
where { <http://hbz.ru/adms/catalog> <http://www.w3.org/ns/dcat#dataset> ?IRI .
                                ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn .
                                ?IRI <http://www.w3.org/ns/dcat#theme> ?cat .
                      OPTIONAL{ ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv }
    FILTER (  strStarts(?dsn, "R") && contains(?dsn, "DF") && ?cat = <http://hbz.ru/adms/internal> )} 
 *
  Пример по двум буквам и названию
select ?IRI ?dsn ?dsv ?dcp ' +
where { <http://hbz.ru/adms/catalog> <http://www.w3.org/ns/dcat#dataset> ?IRI .
    ?IRI <http://www.w3.org/2000/01/rdf-schema#label> ?dsn .
    OPTIONAL{ ?IRI <http://www.w3.org/2002/07/owl#versionInfo> ?dsv }. 
    OPTIONAL{ ?IRI <http://purl.org/dc/terms/description> ?dcp FILTER ((LANG(?dcp) = "ru")) }.  
 FILTER (  (strStarts(?dsn, "S") || strStarts(?dsn, "F")) && contains(?dsn, "O") ) } 

 */

 /** Запрос формируется для сборки Generator. JSON распарсен и сформирован Parser.
  * Парсинг и сборка SPARQL осуществляется пакетом sparqljs 
 */
const N3 = require('n3');
const { DataFactory } = N3;
const { variable, literal, namedNode } = DataFactory;

/** Проверяет, что item является переменной в SPARQL */
const inVariableItem =(item) => {
  return item.termType=="Variable";
};
/** Проверяет, что заданный алиас есть в переменных.  */
const inAliasVariables = (condition, variables) => {
  const av = variables.filter(item => (item.termType=="Variable") && item.value && (item.value == condition.alias));
  return (av.length>0) 
}
/** Служебный метод проверяет наличие и возвращает alias для формировании секции FILTER, если записи 
 * в where нет, то возвращается null.
 * Алиас определяется по значению predicate в triples. Значение алиаса в object соответствующего триплета */
const getAliasInWhere = (condition, where, variables) => {
  console.log("filter.j const getAliasInWhere",condition, where, variables);
  //Проверим variables
  if (inAliasVariables(condition, variables)) return condition.alias;

  const sections = where.filter(item => ["bgp", "optional"].includes(item.type));
  const triples=[];
  for (let i = 0; i < sections.length; i++) {
    const element = sections[i];
    if (element.type=="bgp") 
      triples.push(...element.triples);
    if (element.type=="optional")
      element.patterns.map(item => (item.triples)?triples.push(...item.triples):undefined);
  }
  const alias = triples.filter(item => item.predicate.id==condition.predicate);
  if (alias.length>0) 
    return alias[0].object.value;
  return null;
}
/** Добавление алиаса нового условия. Рекомендуемое значение алиаса в condition.alias
 * в качестве subject используется переменная из where[0].triples[0].object.value
 */
const addAliasInWhere = (condition, where) =>{
  const isIriVariableName = (value) => {
    return typeof value === 'string' && value.toLowerCase() === 'iri';
  };
   const getSubject = () => {
    const triple = where?.[0]?.triples?.[0];

    if (condition.variable) {
      return condition.variable;
    }
    //Если нет переменной в субъекту
    if (triple?.object?.termType === 'NamedNode' || isIriVariableName(triple?.subject?.value))
      return triple?.subject?.value;
    return triple?.object?.value;
  };

  const bgp = where.filter(item => "bgp" == item.type);
  if (bgp.length<1){
    console.log("Section bgp in where not found", where, condition);
    return;
  };

  const subject = getSubject();
  const a = {
    subject: variable(subject), 
    predicate: namedNode(condition.predicate), 
    object: variable(condition.alias) 
  };
  bgp[0].triples.push(a);
}

/** Формирование правой части в условия. Литеральное значение или uri */
const makeSingleValue = (type, value) => {
  return (type=="uri")?namedNode(value): literal(value);
}
/** Формирует конструкцию условия для FILTER в которой указываются два аргумента, операция и 
 * и тип. Тип ВСЕДА type: "operation" */
const makeExpressionLiteralValue = (condition, value) => {
  const arg1 = variable(condition.alias);
  const arg2 = makeSingleValue(condition.type, value);
  return { type: "operation", args:[arg1, arg2], operator: condition.operator};
}
const makeExpressionLiteral = condition => {
  return makeExpressionLiteralValue(condition, condition.value)
}
const makeExpressionArray = (condition, firstValue, otherValues) => {
  const [first, ...other] = otherValues;
  const arg1 = (Array.isArray(otherValues) && (otherValues.length==1))? 
      makeExpressionLiteralValue(condition, otherValues[0])
    : 
      makeExpressionArray(condition, first, other);
  const arg2 = makeExpressionLiteralValue(condition, firstValue);
  return {type: "operation", args:[arg1, arg2], operator: "||" };
}
/** Формирует условие для одного элемента из массива условий. В зависимости от condition.value это может быть
 * makeExpressionLiteral или makeExpressionArray */
const makeExpressionCondition = condition => {
  //console.log("makeExpressionCondition = condition => {", condition);
  if (!Array.isArray(condition.value))
    return makeExpressionLiteral(condition);
  if (condition.value.length==0){
    console.warn("Values conditions is empty", condition);
    return makeExpressionLiteral(condition);
  }
  if (condition.value.length==1)
    return makeExpressionLiteralValue(condition, condition.value[0]);
  const [first, ...other] = condition.value;
  return makeExpressionArray(condition, first, other);
}
/** Рекурсивно формируется запрос. Если осталось одно выражения, то рекурсия оканчивается
 * Если два и более, то формируется условия && и для первого аргумента повторно вызывается 
 * makeExpressionRecursive с conditions уменьшеным на 1, а второй аргумент - последнее условия
 */
const makeExpressionRecursive = (conditions) => {
  if (!Array.isArray(conditions) || (conditions.length==0)) return null;
  if (conditions.length==1)
    return makeExpressionCondition(conditions[0]);
  const [head, ...tail] = conditions;
  return {type: "operation", args:[ makeExpressionRecursive(tail), makeExpressionCondition(head)], operator: "&&" };
}

/** Добавляет в запрос условие для секции where. Одно условия формируется в корневой секции expression
 * Для двух условий формируется && и в args задаются условия.
 * Список условий в  conditions в формате {predicat, alias, operator, value}.
 * alias - переменная, котора определяется в WHERE
 */
export const makeWhereFilter = (request, conditions) => {
  //console.log("makeWhereFilter = (request, conditions)", request, conditions);
  if (!request._request.where){ 
    console.warn("Request not where", request); 
    return request;
  };
  const hasFilter = request._request.where.filter(item => item.type=="filter");
  if (hasFilter.length>0){ 
    console.warn("Request filter not empty", request); 
    return request;
  };
  //Нужно уточнить алиасы, наче будет ошибка в запросе
  for (let i = 0; i < conditions.length; i++) {
    const condition = conditions[i];
    const alias = getAliasInWhere(condition, request._request.where, request._request.variables);
    if (alias) 
      condition.alias = alias
    else 
      addAliasInWhere(condition, request._request.where);
  }
  //console.log("!!!!!!!!!!", conditions); console.log(request._request.where);
  const filter = {type: 'filter', expression: makeExpressionRecursive(conditions) };
  request._request.where.push(filter);
  console.log(request._request.where);
  return request;
};

/** Собирает массив всех переменных, используемых в секции where */
const getAllVariables = (where) => {
  const variables = [];
  where.forEach(item => {
    if (item.type == 'bgp'){
      item.triples.forEach(triple => {
        if (inVariableItem(triple.subject)) variables.push(triple.subject);
        if (inVariableItem(triple.predicate)) variables.push(triple.predicate);
        if (inVariableItem(triple.object)) variables.push(triple.object);
      });
    };
    if (item.type == 'filter'){
      item.expression.args.forEach(arg => {
        if (inVariableItem(arg)) variables.push(arg);
      });
    };
  });
  return variables;
};

/** Особенность метода - добавить ещё фильтры.  newAlias - определяет необходимость 
 * добавить алиасы, т.к. иначе условия наложатся по И*/
export const makeWhereFilterAdv2 = (where, conditions, request, newAlias=false) => {
  //Нужно уточнить алиасы, наче будет ошибка в запросе
  for (let i = 0; i < conditions.length; i++) {
    const condition = conditions[i];
    const variables = getAllVariables(where);
    const alias = getAliasInWhere(condition, where, variables);
    //Заглушка для меток. Иначе дублирование в списке  активов
    if ((condition.alias=="dsn") && inAliasVariables(condition, variables)) continue;
    if (newAlias){
      condition.alias = condition.alias+"_"+i;
      //Это место, которое добавляет в WHERE запись вида ?var <predicat> alias, а затем alias используется в FILTER
      //по умолчанию ?var это object.value
      addAliasInWhere(condition, where);
      continue;
    }
    if (alias) 
      condition.alias = alias
    else 
      addAliasInWhere(condition, where);
  }
  const filter = {type: 'filter', expression: makeExpressionRecursive(conditions) };
  where.push(filter);
  console.log("filter.js makeWhereFilterAdv2", where);
  return request;
}

/** Особенность метода - добавить ещё фильтры.  newAlias - определяет необходимость 
 * добавить алиасы, т.к. иначе условия наложатся по И*/
export const makeWhereFilterAdv = (request, conditions, newAlias=false) => {
  //console.log("makeWhereFilterAdv = (request, conditions, newAlias)", request, conditions, newAlias);
  if (request._request.where){ 
    return makeWhereFilterAdv2(request._request.where, conditions, newAlias, request);
  };
  if (request._request.updates){
    if (request._request.updates[0].where)
      return makeWhereFilterAdv2(request._request.updates[0].where, conditions, newAlias, request);
  };
  console.warn("Request not where", request); 
  return request;
}
